var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leads"},[(_vm.showBasket)?_c('div',{attrs:{"id":"basketWidget"}}):_vm._e(),_c('search')],1)}
var staticRenderFns = []

export { render, staticRenderFns }